import { isBreakpointConfig, createStylesForBreakpoints } from '../helpers/breakpoint';

function getTextAlignment(textAlign) {
  return "text-align: ".concat(textAlign, ";");
}

export function createAlignmentStyles(_ref) {
  var textAlign = _ref.textAlign;

  if (!textAlign) {
    return '';
  }

  if (isBreakpointConfig(textAlign)) {
    return createStylesForBreakpoints(textAlign, getTextAlignment);
  }

  return getTextAlignment(textAlign);
}